export const formatDate = (dateString, options = {}) => {
    if (!dateString) return 'N/A';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';
  
    const defaultOptions = { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    };
    
    return date.toLocaleDateString('en-GB', { ...defaultOptions, ...options });
  };
  
  export const formatDateTime = (dateString) => {
    return formatDate(dateString, {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // export const formatDate = (dateString) => {
  //   if (!dateString) return '—';
  //   const date = new Date(dateString);
  //   return date.toLocaleDateString('en-GB', {
  //     day: '2-digit',
  //     month: 'short',
  //     year: 'numeric'
  //   });
  // };